export class EIRCRequestError extends Error {
  public static errorName = 'EIRCRequestError';

  public constructor(message) {
    super(message);
    this.name = EIRCRequestError.errorName;
  }
}
